import React from 'react'
import './ContactPageSummary.css'

export default function ContactPageSummary() {
    return (
        <div className="ContactPageSummary">
            <p>
                Meal Matchmaker is a random recipe generator so you never run
                out of ideas in the kitchen. After discussing the idea on a UI
                Forum, Adam and Putra teamed up to build the app; coronavirus
                and timezone differences, be damned.
            </p>
            <p>
                Feel free to contact us for work or simply to discuss UX and
                web-mobile development.
            </p>
        </div>
    )
}
